import { render, staticRenderFns } from "./OrdersImport.vue?vue&type=template&id=2a40103b&scoped=true&"
import script from "./OrdersImport.vue?vue&type=script&lang=js&"
export * from "./OrdersImport.vue?vue&type=script&lang=js&"
import style0 from "./OrdersImport.vue?vue&type=style&index=0&id=2a40103b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a40103b",
  null
  
)

export default component.exports